import React from 'react';

/**
 * ###################################
 * @description common type
 * ###################################
 */
// export type TService = 'moashelf' | 'iyagigo' | 'test';
export enum EService {
  GRIDGIO = 'gridgio',
  MOASHELF = 'moashelf',
  IYAGIGO = 'iyagigo',
  OTTERBRICK = 'otterbrick',
  ADMIN = 'admin',
  TEST = 'test',
}

export enum EUserRole {
  USER = 'USER',
  ADMIN = 'ADMIN',
}

export enum ETheme {
  NONE = 'none',
  PAPER = 'paper',
  CUSTOM = 'custom',
  BLACK = 'black',
  BROWN = 'brown',
  CREAM = 'cream',
  GRAY = 'gray',
  YELLOW = 'yellow',
  GREEN = 'green',
  RED = 'red',
  BLUE = 'blue',
  CYAN = 'cyan',
  WHITE = 'white',
}

// 색의 진하기. theme(색상 계열)과 직교.
export type TTone = 'strong' | 'normal' | 'light';

export enum EAuthType {
  INHOUSE = 'inhouse',
  GOOGLE = 'google',
  NAVER = 'naver',
  KAKAO = 'kakao',
  APPLE = 'apple',
}

export type TErrorCode =
  | 'invalid-email-format'
  | 'invalid-username-format'
  | 'invalid-password-format'
  | 'invalid-username-authentication'
  | 'invalid-username-duplicate'
  | 'invalid-password-authentication'
  | 'invalid-password-modification'
  | 'invalid-authentication-code'
  | 'invalid-authentication-code-format'
  | 'invalid-email-duplicate'
  | 'invalid-authtype-oauth'
  | null;

export type TIcon =
  // auth
  | 'logout'
  | 'square-arrow-right-exit'
  | 'account'
  // membership
  | 'ghost'
  | 'smile'
  | 'crown'
  // navigation
  | 'close'
  | 'search'
  | 'menu'
  | 'home'
  | 'window'
  | 'feed'
  | 'bot'
  | 'mic'
  | 'keyboard'
  | 'lightbulb'
  | 'flask'
  | 'today'
  | 'back'
  | 'forward'
  | 'left'
  | 'right'
  | 'up'
  | 'down'
  | 'folder-open'
  | 'files'
  | 'building'
  | 'folder-kanban'
  | 'add-file'
  | 'sort'
  | 'archive-x'
  | 'download'
  | 'share'
  | 'zoom-out'
  | 'zoom-in'
  | 'move'
  | 'palette'
  | 'scan'
  | 'square-dashed'
  | 'flag-triangle-right'
  | 'map-pin-plus'
  | 'clipboard-plus'
  | 'text-align-justify'
  | 'map-pin-off'
  | 'map'
  | 'satellite'
  | 'map-pin'
  | 'clock'
  | 'rotate-left'
  | 'rotate-right'
  // customer
  | 'setting'
  // customer
  | 'info'
  | 'help'
  | 'send'
  | 'save'
  // mail
  | 'mail'
  | 'mail-unread'
  // trash
  | 'pin'
  | 'trash'
  | 'untrash'
  | 'star'
  | 'bookmark'
  | 'label'
  | 'memo'
  | 'memo-text'
  | 'check-box'
  | 'check'
  | 'quiz'
  | 'inventory'
  | 'hash'
  // password
  | 'visibility-on'
  | 'visibility-off'
  // add
  | 'add'
  // note
  | 'edit-note'
  | 'edit'
  | 'pen'
  // expand
  | 'more'
  | 'ellipsis'
  | 'stop'
  | 'less'
  | 'maximize'
  // media
  | 'headphone-on'
  | 'headphone-off'
  | 'play'
  | 'pause'
  | 'replay'
  | 'rewind'
  | 'fast-forward'
  | 'caption-on'
  | 'caption-off'
  | 'language'
  | 'language-off'
  // flag
  | 'flag'
  | 'circle'
  | 'table-chart'
  | 'lock'
  | 'unlock'
  // media
  | 'youtube'
  | 'volume-on'
  | 'volume-off'
  | 'message-circle-text'
  | 'text-snippet'
  | 'text-snippet-off'
  // book
  | 'book'
  | 'notebook-pen'
  // repeat
  | 'repeat'
  // swap (좌우 전환)
  | 'swap'
  // fire
  | 'fire'
  // touch
  | 'touch-app';

// icon
export type TIconKind = 'filled' | 'outlined' | void;
export type TIconSize = 'tiny' | 'small' | 'medium' | 'large' | 'big';

export interface IBlock {
  design: {
    box?: {
      // flex
      direction?: 'row' | 'column';
      alignX?: 'left' | 'center' | 'right';
      alignY?: 'top' | 'center' | 'bottom';
      gap?: string; // e.g: 10px

      // shape
      width?: string; // e.g: 10px
      height?: string; // e.g: 10px
      padding?: string; // e.g: 10px 10px 10px 10px
      margin?: string; // e.g: 10px 10px 10px 10px
      maxWidth?: string;

      // background
      backgroundColor?: string;

      // border
      border?: boolean;
      borderWidth?: string;
      borderStyle?: 'solid' | 'dashed';
      borderColor?: string;
      borderRadius?: string; // e.g: 5px
      borderDirections?: ReadonlyArray<'top' | 'right' | 'bottom' | 'left'>; // e.g: ['top', 'bottom', 'left', 'right']
      shadow?: string; // e.g: '0px 1px 10px 0px rgba(0, 0, 0, 0.15)';

      // visibility
      visibility?: 'visible' | 'hidden';
      opacity?: number;

      // position
      top?: string; // e.g: 10px
      bottom?: string; // e.g: 10px
      left?: string; // e.g: 10px
      right?: string; // e.g: 10px
      transform?: string; // e.g: translate(-50%, -50%)

      // button
      event?: {
        cursor?: 'pointer' | 'auto';
        hover?: string;
      };
      // e.g: `{
      //  background-color: ${color.BLACK_1};
      //  border: none;
      // }`
    };

    text?: {
      // font
      size?: 'tiny' | 'small' | 'medium' | 'large' | 'big' | 'huge' | 'giant';
      color?: string;
      bold?: boolean;
      underline?: boolean;
      underlineColor?: string;
      custom?: {
        fontSize?: number;
      };

      // oneline & multiline
      oneline?: boolean;
      multiline?: number;

      event?: {
        hover?: string;
      };
    };

    icon?: {
      kind?: TIconKind;
      size?: TIconSize;
      color?: string;
      checked?: boolean;
      checkedColor?: string;
    };

    image?: {
      height?: string;
      width?: string;
    };
  };
  click?: {
    handler?: React.MouseEventHandler<HTMLDivElement>;
    mode?: 'throttle' | 'debounce';
    delay?: number;
  };
}

// ############### purchase ###############
export interface IPurchaseOffering {
  identifier: string;
  productId: string;
  priceString: string;
  price: number;
  currencyCode: string;
  title: string;
  description: string;
  period: 'monthly' | 'annual' | 'unknown';
}

export interface IPurchaseResult {
  status: 'success' | 'error';
  productId?: string;
  userCancelled?: boolean;
  error?: {
    code?: string;
    message?: string;
  };
}

export interface IPurchaseStatus {
  isActive: boolean;
  plan: string | null;
  expirationDate: string | null;
  willRenew: boolean;
}

export interface IFuriganaToken {
  text: string;
  ruby?: string;
}

export interface IFuriganaGroup {
  text: string;
  needsRuby: boolean;
}
